import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthState } from './store/reducers/auth.reducer';
import { checkAuthStatus } from './store/actions/auth.action';
import { Observable } from 'rxjs';
import {
  selectWarningBlockedDocument,
  selectWarningDetail,
  selectWarningSummary,
} from './store/selectors/warning.selectors';
import { hideWarning } from './store/actions/warning.action';
import {
  HttpTransportType,
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from '@microsoft/signalr';
import { primengFrenchTranslation } from '../utils/primeng-french-translation.utils';
import { providePrimeNG, PrimeNG } from 'primeng/config';
import { ThemeService } from './core/services/theme.service';
import { ChartThemeService } from './core/services/chart-theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'Angular-project';
  isDarkMode = false;
  warningSummary$: Observable<string>;
  warningDetail$: Observable<string>;
  warningBlockedDocument$: Observable<boolean>;

  private hubConnection!: HubConnection;

  constructor(
    private store: Store,
    private primeng: PrimeNG,
    private themeService: ThemeService,
    theme: ChartThemeService
  ) {
    this.warningSummary$ = this.store.select(selectWarningSummary);
    this.warningDetail$ = this.store.select(selectWarningDetail);
    this.warningBlockedDocument$ = this.store.select(
      selectWarningBlockedDocument
    );
  }

  ngOnInit() {
    this.primeng.setTranslation(primengFrenchTranslation);
    this.themeService.loadTheme();
    this.isDarkMode = this.themeService.getCurrentMode();

  }

  onConfirm() {
    this.store.dispatch(hideWarning());
  }

  onReject() {
    this.store.dispatch(hideWarning());
  }
}
